var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-page"},[_c('shutdown-message'),_c('container',[_c('landing-header'),_c('landing-hero'),_c('landing-guide')],1),_c('landing-payouts'),_c('landing-demo'),_c('landing-action'),_c('container',[_c('landing-footer')],1),_c('login-modal'),_c('register-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }